module.exports = __webpack_public_path__ + "static/media/close-Icon.3c8a6a54.svg";